module.exports = __webpack_public_path__ + "static/media/banner-1.8199225f.webp";